import Redirect from 'app/common/components/redirect';

export default {
  '/api-explorer': {
    components: { main: Redirect },
    from: /\/api-explorer/,
    to: '/api'
  }
};
